import { render, staticRenderFns } from "./app-menu-tabs.vue?vue&type=template&id=341b8f3a&scoped=true&"
import script from "./app-menu-tabs.vue?vue&type=script&lang=js&"
export * from "./app-menu-tabs.vue?vue&type=script&lang=js&"
import style0 from "./app-menu-tabs.vue?vue&type=style&index=0&id=341b8f3a&prod&lang=scss&scoped=true&"
import style1 from "./app-menu-tabs.vue?vue&type=style&index=1&id=341b8f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b8f3a",
  null
  
)

export default component.exports